export enum UserStatus {
  CREATED = 'created',
  ACTIVE = 'active',
  BLOCKED = 'blocked',
}

export type userStatus = 'created' | 'active' | 'blocked';

/**
 *Representa la informacion de un usuario logueado
 *
 * @export
 * @interface User
 */
export interface User {
  /**
   *ID
   *
   * @type {number}
   * @memberof User
   */
  userId: number;

  /**
   *Nombre del usuario
   *
   * @type {string}
   * @memberof User
   */
  name: string;

  /**
   *Correo del usuario
   *
   * @type {string}
   * @memberof User
   */
  email: string;

  /**
   *url del avatar del usuario
   *
   * @type {string}
   * @memberof User
   */
  avatarUrl: string;

  /**
   *Intentos de inicio de sesion
   *
   * @type {number}
   * @memberof User
   */
  retries: number;

  /**
   *Estado del usuario
   *
   * @type {string}
   * @memberof User
   */
  status: userStatus;
}

/**
 *Representa los tokens de una sesion valida
 *
 * @export
 * @interface SessionTokens
 */
export interface SessionTokens {
  /**
   *Token de la sesion, enviado en todas las solicitudes al backend
   *
   * @type {string}
   * @memberof SessionTokens
   */
  sessionToken: string;
  authToken: string;

  /**
   *Token de refresco de sesion, utilizado para crear una nueva sesion
   *
   * @type {string}
   * @memberof SessionTokens
   */
  refreshToken: string;

  /**
   *Tiempo de expiracion de la sesion en milisegundos
   *
   * @type {number}
   * @memberof SessionTokens
   */
  expireTime: number;
}

/**
 *Representa la sesion activa
 *
 * @export
 * @interface Session
 * @extends {SessionTokens}
 */
export interface Session extends SessionTokens {
  /**
   *Usuario propietario de la sesion
   *
   * @type {User}
   * @memberof Session
   */
  user: User;

  /**
   *Fecha de expiracion de la sesion
   *
   * @type {(Date | string)}
   * @memberof Session
   */
  expireDate: Date | string;
}
